export default "__VITE_ASSET__BzFKFuxQ__"